(function() {
  try {
    // Get the URL for the actual theme script from the 'data-sd' attribute
    // of the script tag that loaded this file.
    var themeScriptUrl = document.currentScript.dataset.sd;

    if (themeScriptUrl) {
      // Create a new script element to load the theme functionality directly
      var script = document.createElement('script');
      script.src = themeScriptUrl;
      script.defer = true;
      document.head.appendChild(script);
      
      console.log('Theme script loaded successfully via bypass.');
    } else {
      console.warn('No data-sd attribute found on the script tag.');
    }
  } catch (e) {
    console.error("Error loading theme script:", e);
  }
})();